<style lang="less"></style>

<template>
    <MenuList :menuList="menuList" @handleClicks="(key) => distribute(key)" />
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    declare var eDistributeMode: any;
    import MenuList from "@/app/components/MenuList.vue";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class distributeMenus extends Vue {
        get menuList() {
            return {
                // container: "",
                list: [
                    { key: "vertically", label: this.$t("vertically") },
                    { key: "horizontally", label: this.$t("horizontally") },
                ],
            };
        }
        closeDrop() {
            this.$emit("closeDrop");
        }
        distribute(type: string) {
            if (type === "vertically") {
                this.$track("menu", "layout", "vertically");
                window["_view"].distributeShapes(eDistributeMode.Vertical_SameDist);
            } else {
                this.$track("menu", "layout", "horizontally");
                window["_view"].distributeShapes(eDistributeMode.Horizontal_SameDist);
            }
            this.closeDrop();
        }

        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "vertically": "垂直分布",
    "horizontally": "水平分布"
  },
  "en": {
    "vertically": "Vertical",
    "horizontally": "Horizontal"
  },
  "fr": {
    "vertically": "Distribution verticale",
    "horizontally": "Distribution horizontale"
  },
  "de": {
    "vertically": "Vertikal",
    "horizontally": "Horizontal"
  },
  "jp": {
    "vertically": "垂直",
    "horizontally": "水平"
  },
  "es": {
    "vertically": "Vertical",
    "horizontally": "Horizontal"
  },
  "pt": {
    "vertically": "Vertical",
    "horizontally": "Horizontal"
  },
  "it": {
    "vertically": "Verticale",
    "horizontally": "Orizzontale"
  },
  "tw": {
    "vertically": "垂直分佈",
    "horizontally": "水平分佈"
  }
}
</i18n>
